import React from 'react';
import PropTypes from 'prop-types';

const AddAllButton = ({
  selectSuggestedSites,
  allSuggestedSitesSelected,
}) => {
  return (
    <>
      <div className="site-item row columns">
        <div id="add-all-button-label" className="site-item__checkbox-label" htmlFor="add-all-button-input">
          <input
            aria-label="Select All Publications"
            className="site-item__checkbox-input add-all-button"
            type="checkbox"
            onChange={() => {
              selectSuggestedSites();
            }}
            checked={allSuggestedSitesSelected()}
            id="add-all-button-input"
          />
          <span className="site-item__checkbox" aria-hidden="true" />
          <span className="site-item__add-all-name">Add All</span>
        </div>
      </div>
    </>
  );
};

AddAllButton.propTypes = {
  selectSuggestedSites: PropTypes.func.isRequired,
  allSuggestedSitesSelected: PropTypes.func.isRequired,
};

export default AddAllButton;
